var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRndr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.832 0 32 7.168 32 16C32 24.832 24.832 32 16 32C7.168 32 0 24.832 0 16C0 7.168 7.168 0 16 0Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12.2111C18.0864 12.2111 19.7888 13.9007 19.7888 15.9999C19.7888 18.0863 18.0992 19.7887 16 19.7887C13.9136 19.7887 12.2112 18.0991 12.2112 15.9999C12.2112 13.9135 13.9008 12.2111 16 12.2111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0896 6.09248C17.28 6.10528 18.4576 6.33568 19.5584 6.75808C20.6592 7.18048 21.6832 7.79488 22.5792 8.58848L22.6048 8.61408C24.64 10.4317 25.7536 12.8893 25.8944 15.4109C26.048 17.9453 25.2288 20.5309 23.424 22.5789L23.3984 22.6045C21.5808 24.6397 19.1232 25.7533 16.6016 25.8941C14.0672 26.0477 11.4816 25.2285 9.43363 23.4237C7.38563 21.6061 6.25923 19.1357 6.11843 16.6013C5.96483 14.0669 6.78403 11.4813 8.58883 9.43328L9.44643 10.1885C7.84643 11.9933 7.12963 14.2845 7.25763 16.5245C7.39843 18.7645 8.38403 20.9533 10.1888 22.5533C11.9936 24.1533 14.2848 24.8701 16.5248 24.7421C18.7648 24.6013 20.9536 23.6157 22.5536 21.8109L22.5792 21.7853C24.1664 19.9805 24.8832 17.7021 24.7424 15.4749C24.6016 13.2349 23.616 11.0461 21.8112 9.44608L21.7856 9.42048C21.0048 8.72928 20.1088 8.19168 19.1488 7.82048C18.176 7.44928 17.1392 7.24448 16.0896 7.23168L16.1024 6.07968L16.0896 6.09248Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.368 6.15665C11.0592 6.15665 11.6736 6.43825 12.1216 6.88625C12.5696 7.33425 12.8512 7.96145 12.8512 8.63985C12.8512 9.33105 12.5696 9.94545 12.1216 10.3934C11.6736 10.8414 11.0464 11.123 10.368 11.123C9.6768 11.123 9.0624 10.8414 8.6144 10.3934C8.1664 9.94545 7.8848 9.31825 7.8848 8.63985C7.8848 7.94865 8.1664 7.33425 8.6144 6.88625C9.0624 6.43825 9.6896 6.15665 10.368 6.15665ZM11.3152 7.70545C11.072 7.46225 10.7392 7.30865 10.368 7.30865C9.9968 7.30865 9.664 7.46225 9.4208 7.70545C9.1776 7.94865 9.024 8.28145 9.024 8.65265C9.024 9.02385 9.1776 9.35665 9.4208 9.59985C9.664 9.84305 9.9968 9.99665 10.368 9.99665C10.7392 9.99665 11.072 9.84305 11.3152 9.59985C11.5584 9.35665 11.712 9.02385 11.712 8.65265C11.712 8.28145 11.5584 7.94865 11.3152 7.70545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRndr);
export default __webpack_public_path__ + "static/media/RNDR.cb0f4e10c4fda9e43bf47a0da2bf9af4.svg";
export { ForwardRef as ReactComponent };